@if (environmentName) {
  <div [ngStyle]="backgroundStyle" class="vertical-menu-item environment-Marker" id="environmenMarker">
    <span>{{ environmentName | translate }}</span>
  </div>
}
